import { Component, Vue, Prop } from 'vue-property-decorator';
import { Inject } from 'vue-di-container';
import ProviderService from '../ProviderService';
import WithRender from './AddProvider.html';
import { ProviderModel } from '../ProviderModel';
import { Toaster } from '../../../Services/toast';
import ValidationService from '../../../Services/ValidationService';
import UserModel from '../../../shared/userService/Model/UserModel';
import UserRoleService from '../../../shared/userService/UserRoleService';
import UserService from '../../../shared/userService/UserService';


@WithRender
@Component({
    components: {
    },
    diProvide: [
        UserService,
        UserRoleService,
        ProviderService,
    ],
})
export default class AddProvider extends Vue {
    @Inject(ProviderService) public providerService!: ProviderService;
    @Inject(ValidationService) public validationService!: ValidationService;
    @Inject(UserService) public userService!: UserService;
    @Inject(UserRoleService) public userRoleService!: UserRoleService;

    @Prop({ type: Boolean, default: false })
    public layoutSup: boolean | any;

    @Prop({ type: String, default: 'Add' })
    public mode: string | any;

    @Prop({ default: '' })
    public id!: string;
    public expiryDateMenu: boolean = false;
    public provider: ProviderModel = {
        name: '',
        providerCode: '',
        id: '',
        createdDate: null,
        enterpriseUnifiedNumber: '',
        accreditationNumber: '',
        email: '',
        taxNumber: '',
        hasInternational: false,
        country: '',
        city: '',
        district: '',
        streetName: '',
        buildingNumber: '',
        postalCode: '',
        vatNumber: '',
        additionalNumber: '',
        otherIdentifier: '',
        balance: 0,
        creditLimitAmount: 0,
        bankAccountNumber: '',
        expireDate: '',
        state: '',
        isDisconnected: '',
        integrationBaseURL: ''
    };
    public user: UserModel = {
        userId: '',
        username: '',
        details: {
            Email: '',
            MobilePhone: '',
            Operator: '',
            Provider: '',
            OperatorId: '',
            TenantId: '',
            ProviderId: '',
            Role: '',
            ChangePasswordRequired: '',
        },
    };
    public editProviderDialog: boolean = false;
    public isProvider: boolean = false;
    public validVatNumber: boolean = false;
    public async mounted() {
        this.$emit('childinit', this.layoutSup);
        this.user = await this.userService.getUser();

        const load = async (id: string) => {
            const resp = await this.providerService.GetById(id);
            const data = (resp && resp.result != null) ? resp.result : resp;
            const s = (v: any) => (v == null ? '' : String(v));

            this.provider = {
                ...this.provider,
                ...data,
                name: s(data.name),
                enterpriseUnifiedNumber: s(data.enterpriseUnifiedNumber),
                accreditationNumber: s(data.accreditationNumber),
                taxNumber: s(data.taxNumber),
                email: s(data.email),
                country: s(data.country),
                city: s(data.city),
                district: s(data.district),
                streetName: s(data.streetName),
                buildingNumber: s(data.buildingNumber),
                vatNumber: s(data.vatNumber),
                postalCode: s(data.postalCode),
                additionalNumber: s(data.additionalNumber),
                otherIdentifier: s(data.otherIdentifier),
                bankAccountNumber: s(data.bankAccountNumber),
                expireDate: s(data.expireDate),
                state: s(data.state),
                integrationBaseURL: s(data.integrationBaseURL),
                balance: (data && data.balance != null) ? data.balance : 0,
                creditLimitAmount: (data && data.creditLimitAmount != null) ? data.creditLimitAmount : 0,
                hasInternational: !!(data && data.hasInternational),
                isDisconnected: s(data && data.isDisconnected),
                id: s(data && data.id),
                createdDate: (data && data.createdDate != null) ? data.createdDate : null,
            };
        };

        if (this.user.details.Role === 'Provider Admin' || this.user.details.Role === 'Provider User') {
            this.isProvider = true;
            await load(this.user.details.ProviderId);
        } else if (this.isEditMode) {
            await load(this.id);
        }
    }
    public async addProvider() {
        this.provider.name.trim();
        this.provider.enterpriseUnifiedNumber.trim();
        this.provider.accreditationNumber.trim();
        this.provider.taxNumber.trim();
        const response = await this.providerService.Post(this.provider);
        if (response.isSuccess && response.result) {
            Toaster.success(this.$t('shared.addProviderSuccessfully').toString());
            this.provider = {
                name: '',
                providerCode: '',
                id: '',
                taxNumber: '',
                createdDate: null,
                enterpriseUnifiedNumber: '',
                accreditationNumber: '',
                email: '',
                hasInternational: false,
                country: '',
                city: '',
                district: '',
                streetName: '',
                buildingNumber: '',
                postalCode: '',
                vatNumber: '',
                additionalNumber: '',
                otherIdentifier: '',
                balance: 0,
                creditLimitAmount: 0,
                bankAccountNumber: '',
                expireDate: '',
                state: '',
                isDisconnected: '',
                integrationBaseURL: ''
            };
            this.$router.push({ name: 'Providers' });
        } else {
            Toaster.error(response.errorMessage);
        }
    }
    public showeditProviderDialog(id: string) {
        this.editProviderDialog = true;
    }
    public hideEditProviderDialog() {
        this.editProviderDialog = false;
    }
    public async editProvider() {
        this.provider.name = this.provider.name.trim();
        this.provider.enterpriseUnifiedNumber = this.provider.enterpriseUnifiedNumber.trim();
        this.provider.accreditationNumber = this.provider.accreditationNumber.trim();
        this.provider.taxNumber = this.provider.taxNumber.trim();

        const response = await this.providerService.Put(this.provider);
        if (response.isSuccess && response.result) {
            Toaster.success(this.$t('shared.editProviderSuccessfully').toString());
            this.$router.push({ name: 'Providers' });
        } else {
            Toaster.error(response.errorMessage);
        }
    }
    public get isValid(): boolean {
        this.validVatNumber = (this.provider.vatNumber !== null && this.provider.vatNumber !== '') ?
            this.provider.vatNumber.trim() !== '' : false;
        return (this.provider.name.trim() !== '' &&
            // this.provider.enterpriseUnifiedNumber.trim() !== '' &&
            this.validVatNumber &&
            this.provider.accreditationNumber.trim() !== '' &&
            this.provider.taxNumber.trim() !== '' &&
            (this.provider.expireDate !== '' && this.provider.expireDate !== null) &&
            this.provider.email.trim() !== '' &&
            this.validationService.isValidEmail(this.provider.email.trim())
        );
    }
    public get isEditMode() {
        return (this.mode === 'Edit');
    }

    //public deleteLicenseCertificate() {
    //    this.provider.licenseCertificateName = '';
    //    this.provider.licenseCertificateContent = '';
    //    this.licenseCertificate = '';
    //    (this.$refs.fileLicenseCertificate as any).value = '';
    //}

    public onPickLicenseCertificate() {
        (this.$refs.fileLicenseCertificate as any).click();
    }

    //public onLicenseCertificatePicked(event: any) {
    //    const files: any[] = event.target.files;
    //    Array.prototype.forEach.call(files, (file, index) => {
    //        this.provider.licenseCertificateName = file.name;
    //        this.licenseCertificate = file.name;
    //        const reader = new FileReader();
    //        reader.onloadend = (fileData: any) => {
    //            this.provider.licenseCertificateContent = fileData.target.result.split(',')[1];
    //        };
    //        reader.readAsDataURL(file);
    //    });
    //}
}
